// the order is important to mapping main rol
export enum USER_ROLES {
  anonymous = 'anonymous',
  agency = 'echo-agency',
  brand = 'echo-manager',
  brandUser = 'echo-brand-user',
  creatorEcho = 'echo-creator',
  creatorManaged = 'foam-managed-creator',
  creatorFoam = 'foam-creator',
  talentRep = 'foam-manager',
}
